import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import StudentLoanMortgageGuide from "@/pages/tools/StudentLoanMortgageGuide";

export const Route = createFileRoute("/tools/student-loan-mortgage-guide")({
  head: () => seoHead("/tools/student-loan-mortgage-guide"),
  component: StudentLoanMortgageGuide,
});
